import { BASE_ROUTE, RouteParams } from "../../../constants";

export const BASE_SURVEY_ROUTE = `${BASE_ROUTE}/surveys`;

const SurveyPages = {
  index: {
    path: ``,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_SURVEY_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}`
  },
  preview: {
    path: `/preview/${RouteParams.surveyId}/`,
    generateLink: (organisationId: string | number, projectId: number | string, surveyId: number) =>
      `/${BASE_SURVEY_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/preview/${surveyId}`
  },
  edit: {
    path: `/edit/${RouteParams.surveyId}`,
    generateLink: (
      organisationId: string | number,
      projectId: number | string,
      surveyId: number,
      surveyType?: string
    ) =>
      `/${BASE_SURVEY_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/edit/${surveyId}${surveyType ? `?type=${surveyType}` : ""}`
  },
  create: {
    path: `/create`,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_SURVEY_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/create`
  },
  reporting: {
    path: `/reporting/${RouteParams.surveyId}`,
    generateLink: (organisationId: string | number, projectId: number | string, surveyId: number) =>
      `/${BASE_SURVEY_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/reporting/${surveyId}`
  },
  barometer: {
    path: `/barometer/${RouteParams.surveyId}`,
    generateLink: (organisationId: string | number, projectId: number | string, surveyId: number) =>
      `/${BASE_SURVEY_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/barometer/${surveyId}`
  },
  extended: {
    path: `/survey/${RouteParams.surveyId}`,
    generateLink: (organisationId: string | number, projectId: number | string, surveyId: number) =>
      `/${BASE_SURVEY_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/survey/${surveyId}`
  },
  overview: {
    path: `/overview`,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_SURVEY_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/overview`
  }
};

export default SurveyPages;
